import { create } from "zustand";
import { persist } from "zustand/middleware";

type Mode = "light" | "dark";

interface ThemeStore {
  mode: Mode;
  toggle: () => void;
  set: (m: Mode) => void;
}

function systemPrefersDark(): boolean {
  if (typeof window === "undefined") return false;
  return window.matchMedia?.("(prefers-color-scheme: dark)").matches ?? false;
}

function applyTheme(mode: Mode) {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  if (mode === "dark") {
    root.classList.add("dark");
  } else {
    root.classList.remove("dark");
  }
  root.style.colorScheme = mode;
}

export const useTheme = create<ThemeStore>()(
  persist(
    (set, get) => ({
      mode: systemPrefersDark() ? "dark" : "light",
      toggle: () => {
        const next: Mode = get().mode === "dark" ? "light" : "dark";
        applyTheme(next);
        set({ mode: next });
      },
      set: (m) => {
        applyTheme(m);
        set({ mode: m });
      },
    }),
    {
      name: "email-wrapper-theme",
      onRehydrateStorage: () => (state) => {
        if (state) applyTheme(state.mode);
      },
    },
  ),
);

if (typeof window !== "undefined") {
  // Apply theme before React paints to avoid flash.
  const snapshot = useTheme.getState();
  applyTheme(snapshot.mode);
}
